import { Label } from '@progress/kendo-react-labels'
import { StackLayout } from '@progress/kendo-react-layout'
import { MultiSelect } from '@progress/kendo-react-dropdowns'
import { Input } from '@progress/kendo-react-inputs'

const conpany = ['A会社', 'B会社']

const auth = ['工務担当者', '建材部担当者', '支店担当者', '業者']

export default function AuthSearchCondition() {
  return (
    <>
      <h3>検索条件</h3>

      <StackLayout gap={5} orientation="vertical">
        <Label>会社</Label>
        <MultiSelect data={conpany} />

        <Label>部署</Label>
        <Input />

        <Label>権限</Label>
        <MultiSelect data={auth} />
      </StackLayout>
    </>
  )
}
